import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import { Account } from "./routes/Account";
import { AdminConsole } from "./routes/AdminConsole";
import { AdminWaitlist } from "./routes/AdminWaitlist";
import { AppHome } from "./routes/AppHome";
import { AuthCallback } from "./routes/AuthCallback";
import { ApprovalQueue } from "./routes/ApprovalQueue";
import { BrandBrainEditor } from "./routes/BrandBrainEditor";
import { BrandDetail } from "./routes/BrandDetail";
import { BrandLearn } from "./routes/BrandLearn";
import { Learning } from "./routes/Learning";
import { Calendar } from "./routes/Calendar";
import { GenerateStudio } from "./routes/GenerateStudio";
import { JoinWorkspace } from "./routes/JoinWorkspace";
import { Marketing } from "./routes/Marketing";
import { Media } from "./routes/Media";
import { NewWorkspace } from "./routes/NewWorkspace";
import { NotFound } from "./routes/NotFound";
import { Products } from "./routes/Products";
import { Members } from "./routes/Members";
import { Billing } from "./routes/Billing";
import { Settings } from "./routes/Settings";
import { WorkspaceSso } from "./routes/WorkspaceSso";
import { Inputs } from "./routes/Inputs";
import { SocialAccounts } from "./routes/SocialAccounts";
import { PricingPage } from "./routes/PricingPage";
import { ResetConfirm } from "./routes/ResetConfirm";
import { ResetRequest } from "./routes/ResetRequest";
import { ResetSent } from "./routes/ResetSent";
import { SignIn } from "./routes/SignIn";
import { SignUp } from "./routes/SignUp";
import { SignUpVerify } from "./routes/SignUpVerify";
import { SignUpWaitlist } from "./routes/SignUpWaitlist";
import { Trends } from "./routes/Trends";
import { WorkspaceLanding } from "./routes/WorkspaceLanding";
import { About } from "./routes/About";
import { ApiReference } from "./routes/ApiReference";
import { Changelog } from "./routes/Changelog";
import { Docs } from "./routes/Docs";
import { Security } from "./routes/Security";
import Status from "./routes/Status";
import Mobile from "./routes/Mobile";
import { Terms } from "./routes/legal/Terms";
import { Privacy } from "./routes/legal/Privacy";
import { Dpa } from "./routes/legal/Dpa";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Marketing />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/api" element={<ApiReference />} />
        <Route path="/about" element={<About />} />
        <Route path="/security" element={<Security />} />
        <Route path="/status" element={<Status />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/legal/terms" element={<Terms />} />
        <Route path="/legal/privacy" element={<Privacy />} />
        <Route path="/legal/dpa" element={<Dpa />} />

        <Route path="/signin" element={<SignIn />} />
        <Route path="/signin/:wsId" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signup/verify" element={<SignUpVerify />} />
        <Route path="/signup/waitlist" element={<SignUpWaitlist />} />
        <Route path="/reset" element={<ResetRequest />} />
        <Route path="/reset/sent" element={<ResetSent />} />
        <Route path="/reset/confirm" element={<ResetConfirm />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        <Route path="/app" element={<AppHome />} />
        <Route path="/app/new-workspace" element={<NewWorkspace />} />
        <Route path="/w/:ws" element={<WorkspaceLanding />} />
        <Route path="/w/:ws/members" element={<Members />} />
        <Route path="/w/:ws/billing" element={<Billing />} />
        <Route path="/w/:ws/settings" element={<Settings />} />
        <Route path="/w/:ws/sso" element={<WorkspaceSso />} />
        <Route path="/w/:ws/join/:token" element={<JoinWorkspace />} />
        <Route path="/w/:ws/b/:brand" element={<BrandDetail />} />
        <Route path="/w/:ws/b/:brand/edit" element={<BrandBrainEditor />} />
        <Route path="/w/:ws/b/:brand/products" element={<Products />} />
        <Route path="/w/:ws/b/:brand/trends" element={<Trends />} />
        <Route path="/w/:ws/b/:brand/media" element={<Media />} />
        <Route path="/w/:ws/b/:brand/learn" element={<BrandLearn />} />
        <Route path="/w/:ws/b/:brand/learning" element={<Learning />} />
        <Route path="/w/:ws/b/:brand/inputs" element={<Inputs />} />
        <Route path="/w/:ws/b/:brand/accounts" element={<SocialAccounts />} />
        <Route path="/w/:ws/b/:brand/generate" element={<GenerateStudio />} />
        <Route path="/w/:ws/b/:brand/queue" element={<ApprovalQueue />} />
        <Route path="/w/:ws/b/:brand/calendar" element={<Calendar />} />

        <Route path="/account" element={<Account />} />
        <Route path="/admin" element={<AdminConsole />} />
        <Route path="/admin/waitlist" element={<AdminWaitlist />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
